import { render, staticRenderFns } from "./order_notClose.vue?vue&type=template&id=ba400c8e&scoped=true"
import script from "./order_notClose.vue?vue&type=script&lang=js"
export * from "./order_notClose.vue?vue&type=script&lang=js"
import style0 from "./order_notClose.vue?vue&type=style&index=0&id=ba400c8e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba400c8e",
  null
  
)

export default component.exports